import { render, staticRenderFns } from "./szHistogram.vue?vue&type=template&id=617300fd&scoped=true&"
import script from "./szHistogram.vue?vue&type=script&lang=js&"
export * from "./szHistogram.vue?vue&type=script&lang=js&"
import style0 from "./szHistogram.vue?vue&type=style&index=0&id=617300fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617300fd",
  null
  
)

export default component.exports